import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1, drainPages } from '../apis.js';
import { insightsQuery } from '../insights/filter-params.js';
const reqCases = collectionEngineV1('/case-vouchers');
export const getMultiple = (query, pagination) => reqCases('GET', `/?${toQuery({
    ...query,
    ...pagination,
})}`);
const CASE_VOUCHERS_PAGE_SIZE = 500;
// Pages to the end rather than taking the first page: a long running case can
// hold more vouchers than one page, and a case view that quietly showed the
// first 500 would be wrong in exactly the cases that matter.
export const getByCaseId = (caseId, options) => drainPages((page) => getMultiple({ caseId, getDeleted: options.getDeleted }, { page, pageSize: CASE_VOUCHERS_PAGE_SIZE }), CASE_VOUCHERS_PAGE_SIZE);
export const getById = (id) => reqCases('GET', `/by-id/${id}`);
export const getRecognitions = (transactionAccountId) => reqCases('GET', `/recognitions?${toQuery({ transactionAccountId })}`);
export const mapCaseVouchers = (mappings) => reqCases('POST', '/map', { body: { mappings } });
export const create = (caseId, newCaseVoucher, config) => reqCases('POST', `/${caseId}${config?.preventAdjustments ? '?preventAdjustments=true' : ''}`, {
    body: newCaseVoucher,
});
export const patchCaseVoucher = (caseVoucherId, patch, config) => reqCases('PATCH', `/${caseVoucherId}${config?.preventAdjustments ? '?preventAdjustments=true' : ''}`, {
    body: patch,
});
export const setBookingDate = (caseVoucherIds, bookingDate) => reqCases('PATCH', '/booking-date', {
    body: { caseVoucherIds, bookingDate },
});
export const markCaseVouchersExpired = (caseVoucherIds) => reqCases('POST', '/mark-expired', { body: { caseVoucherIds } });
export const delCaseVoucher = (caseVoucherId, config) => {
    const params = new URLSearchParams();
    if (config?.preventAdjustments) {
        params.set('preventAdjustments', 'true');
    }
    if (config?.cascadeFixedDistributions) {
        params.set('cascadeFixedDistributions', 'true');
    }
    const query = params.toString();
    return reqCases('DELETE', `/${caseVoucherId}${query ? `?${query}` : ''}`);
};
export const getDepositInsights = () => reqCases('GET', '/insights/deposits');
export const getExpirationInsightsByMonth = ({ caseGroupIds = [], creditorIds = [], } = {}) => reqCases('GET', `/insights/expiration-by-month${insightsQuery({ base: {}, scope: { caseGroupIds, creditorIds } })}`);
export const getExpirationInsightsBreakdownForMonth = (month, { caseGroupIds = [], creditorIds = [], } = {}) => reqCases('GET', `/insights/expiration-by-month/${encodeURIComponent(month)}/breakdown${insightsQuery({ base: {}, scope: { caseGroupIds, creditorIds } })}`);
export const getExpirationSuspensionInsightsByMonthAndType = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => reqCases('GET', `/insights/expiration-suspension-by-month-and-type${insightsQuery({ base: { from, to }, scope: { caseGroupIds, creditorIds } })}`);
export const getPortfolioCompositionByMonth = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => reqCases('GET', `/insights/portfolio-composition-by-month${insightsQuery({ base: { from, to }, scope: { caseGroupIds, creditorIds } })}`);
export const getIncomingPaymentsInsights = (from, to, { caseGroupIds = [], creditorIds = [], } = {}) => reqCases('GET', `/insights/incoming-payments${insightsQuery({ base: { from, to }, scope: { caseGroupIds, creditorIds } })}`);
export const restoreCaseVoucher = (caseVoucherId) => reqCases('POST', `/${caseVoucherId}/restore`);
export const createCounterEntry = (caseVoucherId, amount) => reqCases('POST', `/${caseVoucherId}/counter-entry`, { body: { amount } });
export const checkForDuplicates = async (creditorId, vouchers) => await reqCases('POST', '/duplicates/' + creditorId, {
    body: { vouchers },
});
//# sourceMappingURL=case-vouchers.js.map